/**
 * Toggle hide or show element when clicked
 */
angular.module('gateApp').directive('swCollapse', () => ({
  restrict: 'A',
  scope: true,

  controller: function ($element) {
    this.toggle = () => {
      $element.toggleClass('open');
    };
  },

  // TODO CORE-1009 remove magic controller name, and whole directive.
  controllerAs: 'Collapse',
}));
